import type { Schemas } from "#shopware";

export const useShopwareProductReviewStats = async (product: Schemas["Product"]) => {
	const { apiClient } = useShopwareContext();

	const { data } = await apiClient.invoke("readReviewStats get /product/{id}/reviews/stats", {
		pathParams: { id: product.id }
	});

	return data;
};
